import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { AlertType } from '../components/confirm-modal/confirm-modal.component';
import { ModalConfiguration } from '../models/modal-configuration.model';
import { Modal } from '../models/modal.model';
import { ModalService, IAlertDialogParameters, IConfirmDialogParameters } from './modal.service';

@Injectable()
export class ModalLocalService {
  public constructor(
    private readonly modalService: ModalService,
    private readonly dialog: MatDialog,
  ) {}

  public open<TComponent, TParameters = void>(
    componentType: ComponentType<TComponent>,
    configuration: ModalConfiguration,
    parent?: Modal,
    parameters?: TParameters,
  ): Modal<TParameters> {
    return this.modalService.open<TComponent, TParameters>(componentType, configuration, parent, parameters);
  }

  public openModal<TComponent, TParameters = {}>(
    componentType: ComponentType<TComponent>,
    parameters: TParameters,
  ): MatDialogRef<TComponent, TParameters> {
    const modal = this.dialog.open(componentType, {
      data: parameters,
    });

    return modal;
  }

  public closeAll(): void {
    this.modalService.closeAll();
  }

  public showAlertPopup(
    type: AlertType,
    title: string,
    message: string,
    options: IAlertDialogParameters = { confirmText: TranslationKeys.GeneralOk },
  ): Modal {
    return this.modalService.showAlertPopup(type, title, message, options);
  }

  public showConfirmationPopup(
    type: AlertType,
    title: string,
    message: string,
    options: IConfirmDialogParameters = { confirmText: TranslationKeys.GeneralConfirm, rejectText: TranslationKeys.GeneralCancel },
  ): Modal {
    return this.modalService.showConfirmationPopup(type, title, message, options);
  }
}
